import { render, staticRenderFns } from "./OrgAdmin.vue?vue&type=template&id=e2c68a08&"
import script from "./OrgAdmin.vue?vue&type=script&lang=js&"
export * from "./OrgAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports